export default __webpack_public_path__ + "static/media/play2.72ee6842.svg";